import Button from 'components/button'
import useRouter from 'hooks/use-router'
import textServices from 'services/text-services'
import { ButtonMenu, SpanMenu } from 'theme/header'

interface IProps {
  setShowIntroduction: (show: boolean) => void
}

function IntroductionTrivia({ setShowIntroduction }: IProps) {

  const { history } = useRouter()

  const closeIntroduction = () => {
    localStorage.setItem('introductionTrivias', 'true')
    setShowIntroduction(false)
  }

  return (
    <div className="w-full flex-1 pb-8">
      <ButtonMenu
        className="w-24 h-24 p-8 absolute top-0 right-0"
        open={true}
        onClick={() => {
          gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'HOME - Cerrar informacion del baner', value: '10' })
          closeIntroduction()
        }}
      >
        <SpanMenu open={true} className={`transition block h-0.5 w-8 transform rotate-45 -mb-0.5`} />
        <SpanMenu open={true} className={`transition block h-0.5 w-8 transform -rotate-45 -mb-0.5`} />
      </ButtonMenu>
      <img src={`${AZURE_BASE_URL}/popup-trivias-mobile.svg`} className="w-full" />
      <div className='px-8 flex flex-col items-center gap-4'>
        <Button onClick={closeIntroduction}>
          {textServices.findByText('trivia/introduction', 'PARTICIPA AQUÍ')}
        </Button>
        <button type="button" className="cursor-pointer" onClick={() => history.goBack()}>
          <p
            className={`din text-center uppercase underline`}
            style={{ fontSize: 10 }}
          >
            VOLVER
          </p>
        </button>
      </div>
    </div>
  )
}

export default IntroductionTrivia